export default "__VITE_ASSET__JFCB6yR3__"